// extracted by mini-css-extract-plugin
export default {"menu":"ProductMenu_menu__JkLyq","wrapper":"ProductMenu_wrapper__YuJnu"};